import { render, staticRenderFns } from "./TankerTrucks.vue?vue&type=template&id=686f8732"
import script from "./TankerTrucks.vue?vue&type=script&lang=js"
export * from "./TankerTrucks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports